// Redux form
const PERIOD_FORM_NAME = 'periodForm';
export default PERIOD_FORM_NAME;
